import avatar1 from '../assets/users/1.png'
import avatar2 from '../assets/users/2.png'
import avatar3 from '../assets/users/3.png'
import avatar4 from '../assets/users/4.png'
import avatar5 from '../assets/users/5.png'

export const avatarData = [
	{
		id: 0,
		img: avatar1,
		alt: "user1",
		name: "Sophie"
	},
	{
		id: 1,
		img: avatar2,
		alt: "user2",
		name: "Teddy"
	},
	{
		id: 2,
		img: avatar3,
		alt: "user3",
		name: "Kids"
	},
	{
		id: 3,
		img: avatar4,
		alt: "user4",
		name: "Dad"
	},
	{
		id: 4,
		img: avatar5,
		alt: "user5",
		name: "Mom"
	},
];
